<div class="detail-sidebars" id="detail-sidebar">

  <mat-accordion multi>





    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="fas fa-edit"></i>
          Edit
        </mat-panel-title>
      </mat-expansion-panel-header>


      @if (loom?.loomForm.get('loomtype')?.value !== 'jacquard') {

      <mat-label>
        Drafting Style
        <button class="draft-style-info-button" matIconButton matTooltip="More Information"
          (click)="openMoreInformation()"><i class="fas fa-info-circle"></i></button>
      </mat-label>

      <div class="editing-mode-toggle">
        <mat-button-toggle-group [formControl]="editingModeForm" name="design source" aria-label="edit mode">
          <mat-button-toggle name="loom" matTooltip="threading-first" class="draft-edit-mode-loom"
            value="loom"></mat-button-toggle>
          <mat-button-toggle name="drawdown" matTooltip="drawdown-first" class="draft-edit-mode-drawdown"
            value="drawdown">
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      }


      <div class="draft_tools">

        <mat-accordion displayMode="flat" hideToggle>

          <mat-expansion-panel #drawToolsPanel>
            <mat-expansion-panel-header>
              <mat-panel-title [class.is-active]="pencilForm?.value !== 'select'">
                <i class="fas fa-pencil"></i> Draw
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="draw">

              <mat-button-toggle-group class="draw_modes_group" name="editor mode" [formControl]="pencilForm"
                aria-label="edit mode">

                @for (mode of draw_modes; track mode) {
                <mat-button-toggle class="draw_mode_button" [matTooltip]="mode.viewValue" [value]="mode.value">
                  <span [style.color]="mode.color"><i class=" {{mode.icon}}"
                      [style.font-size]="mode.size + 'em'"></i></span>
                </mat-button-toggle>
                }
              </mat-button-toggle-group>


              <button class="add-materials-button" matButton="filled" matTooltip="edit materials"
                (click)="editMaterials()">
                <i class="fas fa-plus"></i> Add/Edit Materials
              </button>
            </div>
          </mat-expansion-panel>






          <mat-expansion-panel #selectToolsPanel>
            <mat-expansion-panel-header>
              <mat-panel-title [class.is-active]="pencilForm?.value === 'select'">
                <i class="fas fa-expand"></i> Select (shift + drag)
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="select">



              @if(!hasSelection && pencilModeForm?.value == 'select') {
              <div class="selection_status">
                <span>Shift + Drag to select a region on the draft</span>
              </div>
              }
              @if(hasSelection && pencilModeForm?.value == 'select') {

              <button matButton="outlined" color="accent" matTooltip="Clear Selection" (click)="clearSelection()"><i
                  class="fas fa-times"></i> Clear
                Selection</button>
              }


              <div class="design-actions">

                @for (action of designActions; track action) {
                <button [class]="action.value" [disabled]="!hasSelection || !action.enabled" matMiniFab color="accent"
                  [matTooltip]="action.viewValue" (click)="designActionChange(action.value)">
                  <i class="fas fa-{{action.icon}}"></i>
                </button>
                }
              </div>


            </div>
          </mat-expansion-panel>
        </mat-accordion>


        <!-- <mat-label>Pen Mode</mat-label>
        <mat-button-toggle-group name="pencilModeForm" [formControl]="pencilModeForm" aria-label="edit mode">
          <mat-button-toggle value="select" matTooltip="select regions"><i class="fas fa-expand"></i> Select
            Regions</mat-button-toggle>
          <mat-button-toggle value="draw" matTooltip="draw"><i class="fas fa-pencil"></i> Draw</mat-button-toggle>
        </mat-button-toggle-group> -->







      </div>



    </mat-expansion-panel>




    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="fa-solid fa-gear"></i>
          Edit Loom Settings
        </mat-panel-title>

      </mat-expansion-panel-header>

      <app-loom #loom [draftRendering]="weaveRef" (unsetSelection)='unsetSelection()'
        (drawdownUpdated)='drawdownUpdated()'></app-loom>
    </mat-expansion-panel>


    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="fa-solid fa-circle-info"></i>
          Information
        </mat-panel-title>

      </mat-expansion-panel-header>

      @if (dressing_info.length > 0) {
      @for (line of dressing_info; track line) {
      <div>
        {{line.label}}: {{line.value}}
      </div>
      }}

      @if (dressing_info.length === 0) {
      <div>
        No dressing information available
      </div>
      }


    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title><i class="fa-solid fa-plus"></i> New / Import</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="new-draft-buttons">
        <button mat-stroked-button class="new_draft" color="primary" matTooltip="Blank Draft"
          (click)="createNewDraft()">
          + <i class="fas fa-chess-board"></i> new draft
        </button>

        <button mat-stroked-button class="new_draft" color="primary" matTooltip="Blank Draft"
          (click)="import('bitmap')">
          import from bitmap
        </button>

        <button mat-stroked-button class="new_draft" color="primary" matTooltip="Blank Draft" (click)="import('wif')">
          import from wif
        </button>
      </div>

    </mat-expansion-panel>




  </mat-accordion>

</div>

<div class="draft-container" id="editor-draft-container">


  <div [class.hidden]="parentOp == ''" class="locked_draft">
    <p>Edits are disabled by default because the draft you are viewing was generated by the <b>{{parentOp}}</b>
      operation. <button mat-raised-button color="warn" (click)="enableEdits()">Enable Edits</button>
  </div>



  <div class="scale-container" id="editor-scale-container">
    <app-draft-rendering #weaveRef source="editor" [id]="id" [scale]="1" [view_only]="false"
      [current_view]="current_view" (onNewSelection)="updateSelection($event)" (onDrawdownUpdated)="drawdownUpdated()">
    </app-draft-rendering>
  </div>
</div>